import clsx from 'clsx';
import { Base } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "CategoryBadge-root_2Ieph",
  "big": "CategoryBadge-big_2YyyV",
  "small": "CategoryBadge-small_M-DzQ",
  "left": "CategoryBadge-left_AFsX7",
  "right": "CategoryBadge-right_alhS8",
  "default": "CategoryBadge-default_15Sq1",
  "orange": "CategoryBadge-orange_32yT7",
  "red": "CategoryBadge-red_T3bSO",
  "green": "CategoryBadge-green_3kTnb",
  "purple": "CategoryBadge-purple_3NJj8",
  "blue": "CategoryBadge-blue_LYaVN",
  "primary": "CategoryBadge-primary_2Wkn3"
};
export function CategoryBadge({
  children,
  side = 'left',
  size = 'big',
  theme = 'default'
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "h3",
    className: clsx(styles.root, styles[size], styles[side], styles[theme]),
    size: size,
    children: children
  });
}